// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__vcSBP","label":"styles_label__ISR1f","icon":"styles_icon__DKa59"};